module.exports = __webpack_public_path__ + "img/zhishizhongxinhoutai.cd9b9a4e.png";